import { APIData } from './common.constant';

export const DefaultVersion = 2;

/**
 * @typedef {Object} IProduct
 * @property {number} ProductId
 * @property {string} ProductName
 * @property {string} ProductTitle
 * @property {string} displayTitle
 * @property {string} PrescriberProductDisplayName
 * @property {string} ProductType
 * @property {string} OrderType
 * @property {boolean} AutRefill
 * @property {boolean} HCPCompleteOnly
 * @property {boolean} IsAlternateRx
 * @property {boolean} IsLabProduct
 * @property {string} ProductAutRefill
 * @property {number} Qty
 * @property {string} Status
 */

/**
 * @typedef {Object} IProductInfo
 * @property {string} OrderDate
 * @property {number} OrderId
 * @property {number} Patientid
 * @property {IProduct[]} Product
 * @property {boolean} ShowApproveButton
 * @property {boolean} ShowCompleteVisitButton
 */

export const ProductInfo = () => ({
  productInfo: {
    api: APIData({}),
    OrderDate: '',
    OrderId: '',
    Product: [],
    StoreFrontData: {
      StorefrontName: '',
      CompanyId: '',
      WorkingName: '',
      EmailDomain: '',
      StorefrontApplicationSettings: new Map(),
    },
    StoreFrontURL: '',
    ShowApproveButton: false,
    ShowCompleteVisitButton: false,
    productIds: [],
    productMap: new Map(),
    productSet: new Set(),
    pdfInfo: {
      productId: 0,
      template: '',
    },
  },
});

/**
 * @typedef {Object} ISelectedPatientInfo
 * @property {{
 *  called: boolean;
 *  loading: boolean;
 * }} api
 * @property {number} UserId
 * @property {string} PreName
 * @property {string} FirstName
 * @property {string} LastName
 * @property {string} DOB
 * @property {number} Age
 * @property {string} Gender
 * @property {string} Height
 * @property {string} Weight
 * @property {string} BMI
 * @property {string} City
 * @property {string} State
 * @property {string} StartDateTime_UTC
 * @property {string} EndDateTime_UTC
 * @property {string} ICDCodes
 * @property {string} ICDDescriptions
 * @property {string} ICDCodesAndDescriptions
 * @property {string} ICDDescriptionsAndCodes
 */

/**
 * @typedef {Object} IPatientInfo
 * @property {ISelectedPatientInfo} selectedPatientInfo
 */

/**
 * @returns {IPatientInfo}
 */
export const PatientInfo = () => ({
  selectedPatientInfo: {
    api: APIData(),
    UserId: 0,
    PreName: '',
    FirstName: '',
    LastName: '',
    DOB: '',
    Age: 0,
    Gender: '',
    Height: '',
    Weight: '',
    BMI: '',
    City: '',
    State: '',
    StorefrontMedications: [],
    Allergies: [],
    PersonalMedicatoins: [],
    SeriousIllness: [],
    StartDateTime_UTC: '',
    EndDateTime_UTC: '',
    ICDCodes: '',
    ICDDescriptions: '',
    ICDCodesAndDescriptions: '',
    ICDDescriptionsAndCodes: '',
  },
});

export const EmailReason = () => ({
  id: -1,
  label: '',
  value: -1,
  required: false,
  description: '',
});

export const AddProductInfo = () => ({
  addProductInfo: {
    api: APIData({}),
  }
});

export const IEmailTemplate = () => ({
  id: -1,
  pId: -1,
  salesforceId: '',
  name: '',
  title: '',
  label: '',
  body: '',
  subject: '',
  value: -1,

  Id: '',
  EmailMessageId: -1,
  ProductId: -1,
  EmailTemplateTitle: '',
  EmailTemplateBody: '',
  EmailTemplateSubject: '',
});

/**
 * @typedef {Object} IEmailTemplate
 * @property {number} id
 * @property {number} pId
 * @property {string} name
 * @property {string} title
 */

/**
 * @typedef {Object} IEmailTemplateWithProductId
 * @property {number} productId
 * @property {IEmailTemplate[]} templateList
 */

export const IEmailTemplateWithProductId = () => {
  const _interface = {
    productId: 0,
    templateList: [IEmailTemplate()],
  };
  _interface.templateList = [];
  return _interface;
};

export const ISFEmailTemplateResponse = () => {
  const _interface = {
    storefrontName: '',
    templateWithProductIds: [IEmailTemplateWithProductId()],
  };
  _interface.templateWithProductIds = [];
  return _interface;
};

export const DefaultSFEmailTemplatesResponse = ISFEmailTemplateResponse();

export let SF_EMAIL_TEMPLATES_RESPONSE = ISFEmailTemplateResponse();
SF_EMAIL_TEMPLATES_RESPONSE = {
  storefrontName: 'GetNeffy.com',
  templateWithProductIds: [
    {
      productId: 1482,
      templateList: [
        {
          Id: 'Ghr690y',
          name: 'Approve Email Template',
          body: `<html>\n<head>\n\t<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\nHi Abhisek,<br />\n<br />\nYour Contrave approve email test will be performed at a Lucid Test Center, and they will be contacting you soon to get you scheduled and answer any questions you may have. Just in case you don't hear from them or want to get started ASAP, here's their phone number: (623) 687-2386.<br />\n<br />\nThank you,<br />\n<br />\nLevaRx.com Patient Support<br />\nservice@LevaRx.com<br />\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<<DOCTOR>>\n(800) 835-6538</p>\n\n</body></html>`,
          subject: 'Contrave Approve Testing Center Info',
        },
      ],
    },
    {
      productId: 1482,
      templateList: [
        {
          Id: 'Ghr690j',
          name: 'Send Email Template',
          body: `<html>\n<head>\n\t<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\nHi Abhisek02,<br />\n<br />\nYour Contrave send email test will be performed at a Lucid Test Center, and they will be contacting you soon to get you scheduled and answer any questions you may have. Just in case you don't hear from them or want to get started ASAP, here's their phone number: (623) 687-2386.<br />\n<br />\nThank you,<br />\n<br />\nLevaRx.com Patient Support<br />\nservice@LevaRx.com<br />\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n(800) 835-6538</p>\n\n</body></html>`,
          subject: 'Contrave Send Testing Center Info',
        },
      ],
    },
    {
      productId: 1482,
      templateList: [
        {
          Id: 'Ghr690k',
          name: 'Email Template',
          body: `<html>\n<head>\n\t<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\nHi Abhisek03,<br />\n<br />\nYour Contrave email test will be performed at a Lucid Test Center, and they will be contacting you soon to get you scheduled and answer any questions you may have. Just in case you don't hear from them or want to get started ASAP, here's their phone number: (623) 687-2386.<br />\n<br />\nThank you,<br />\n<br />\nLevaRx.com Patient Support<br />\nservice@LevaRx.com<br />\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n(800) 835-6538</p>\n\n</body></html>`,
          subject: 'Contrave Email Testing Center Info',
        },
      ],
    },
    {
      productId: 1482,
      templateList: [
        {
          Id: 'Ghr690l',
          name: 'Deny Email Template',
          body: `<html>\n<head>\n\t<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\nHi Abhisek04,<br />\n<br />\nYour Contrave deny email test will be performed at a Lucid Test Center, and they will be contacting you soon to get you scheduled and answer any questions you may have. Just in case you don't hear from them or want to get started ASAP, here's their phone number: (623) 687-2386.<br />\n<br />\nThank you,<br />\n<br />\nLevaRx.com Patient Support<br />\nservice@LevaRx.com<br />\n<style type="text/css"><!--td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;}-->\n</style>\n(800) 835-6538</p>\n\n</body></html>`,
          subject: 'Contrave Deny Testing Center Info',
        },
      ],
    },
  ],
};

export const CRITICAL_FLAG = () => ({
  flagId: 0,
  flagText: '',
  required: true,
});

export const CRITICAL_FLAGS = () => {
  const _interface = {
    api: {
      ...APIData(),
      data: [CRITICAL_FLAG()],
    },
  };
  _interface.api.data = [];
  return _interface;
};

export const DOCTOR_FLAG = () => ({
  flagId: 0,
  flagText: '',
  required: true,
});

export const DOCTOR_FLAGS = () => {
  const _interface = {
    api: {
      ...APIData(),
      data: [DOCTOR_FLAG()],
    },
  };
  _interface.api.data = [];
  return _interface;
};

export const ORDER_FLAG = () => ({
  flagId: 0,
  productId: 0,
  questionId: 0,
  flagText: '',
  flagHeader: '', // flagText will be replaced with flagHeader in controller to match CRW-2659
  flaggedQuestion: '',
  flaggedAnswer: '',
  required: true,
});

export const PRESCRIBER_FLAG = () => ({
  ProductId: 0,
  QuestionId:  0,
  ConsultidconsultationId: 0,
  PrescriberFlagText: '',
  FlaggedQuestion: '',
  FlaggedAnswer: '',
  Required: true,
});

export const ORDER_AND_PRESCRIBER_FLAGS = () => {
  const _interface = {
    api: {
      ...APIData(),
      data: {
        OrderFlags: [''],
        OrderFlagsV2: [ORDER_FLAG()],
        PrescriberFlags: [PRESCRIBER_FLAG()],
        DoctorId: 0,
      }
    },
  };
  _interface.api.data.OrderFlags = [];
  _interface.api.data.OrderFlagsV2 = [];
  _interface.api.data.PrescriberFlags = [];
  return _interface;
};

export const SAVED_FLAG = () => ({
  id: 0,
  flagId: 0,
  flagType: '',
  checked: false,
  note: '',
  required: true,
  orderId: 0,
  productId: 0,
  questionId: 0,
  updatedBy: 0,
  updatedAt: '',
  responseId: '',
});

export const SAVED_FLAGS = () => {
  const _interface = {
    flagsCollection: new Map([
      ['', SAVED_FLAG()],
    ]),
    api: {
      ...APIData(),
      data: [SAVED_FLAG()],
    },
  };
  _interface.flagsCollection.delete('');
  _interface.api.data = [];
  return _interface;
};

export const ORDERS = () => ({
  scheduled: {
    collection: new Map([
      [0, {}],
    ]),
  },
  _async: {
    collection: new Map([
      [0, {}],
    ]),
  },
  all: {
    collection: new Map([
      [0, {}],
    ]),
  },
});

export const FLAG_TYPE = {
  ORDER: 'order',
  PRESCRIBER: 'prescriber',
};

export const LOADING_ROWS = [
  {
    key: 1,
  },
  {
    key: 2,
  },
  {
    key: 3,
  },
];

export const SOAP_NOTE_TEMPLATES = () => [
  {
    Id: 228,
    TemplateTitle: "Approve - New to Brand - Synch - Acute Nurtec",
    TemplateText:
      "S: Introduced myself and confirmed the patient's name and DOB. <<Age>> year old <<gender>> requests an Rx to treat migraines. Medical consult, patient's current medications, and patient's current allergies reviewed and all are noncontributory unless otherwise noted here. \nPatient does not have uncontrolled hypertension, heart disease or condition, history of stroke, peripheral vascular disease, or ischemic bowel disease.  Patient medical history does not indicate headaches due to medication overuse.\nPatient experiences __________ migraine days per month with an average pain rate of ________.\nTo prevent migraines, the patient has tried ___________  and failed due to ___________ \nFor the acute treatment of migraines, the patient has tried ___________  and failed due to ___________ \n\nO: Synchronous Visit.  Current BMI <<BMI>>, lucid and clear, speaking full sentences, respiratory unlabored. Normal blood pressure reported. \n\nA: Migraine Headaches. ICD-10 code <<ICD_Codes>> Descriptions: <<ICD_DESCRIPTIONS>>\n\nP: Nurtec approved. Given the number of migraine days, severity of symptoms, and history of medications tried and failed, the patient will benefit from the use of Nurtec for the acute treatment of migraines.  Review of the patient's medical file, including current medications, demonstrates no apparent contraindications for use. All questions were answered satisfactorily and the patient understood and agreed to the plan. Provided the patient with my contact information for any questions or concerns. Follow-up in 3 months for a refill or PRN. \n",
  },
  {
    Id: 231,
    TemplateTitle: "Approve - Renew Script - Synch - Acute Nurtec",
    TemplateText:
      "S: Introduced myself and confirmed the patient's name and DOB. <<Age>> year old <<gender>> requests a refill of Nurtec to treat migraines. Has taken Nurtec with good outcome and no side effects. Medical consult, patient’s current medications, and patient’s current allergies reviewed and all are noncontributory unless otherwise noted here. \nPatient does not have uncontrolled hypertension, heart disease or condition, history of stroke, peripheral vascular disease, or ischemic bowel disease.  Patient medical history does not indicate headaches due to medication overuse.\nPatient experiences __________ migraine days per month with an average pain rate of ________.\nTo prevent migraines, the patient has tried ___________  and failed due to ___________ \nFor the acute treatment of migraines, the patient has tried ___________  and failed due to ___________ \n\nO: Synchronous Visit.  Current BMI <<BMI>>, lucid and clear, speaking full sentences, respiratory unlabored. Normal blood pressure reported. \n\nA: Migraine Headaches. ICD 10 code <<ICD_DESCRIPTIONS>>\n\nP: Nurtec approved. Given the number of migraine days, severity of symptoms, history of medications tried and failed, and success with Nurtec, the patient will benefit from the continued use of Nurtec for the acute treatment of migraines.  Review of the patient’s medical file, including current medications, demonstrates no apparent contraindications for use. All questions were answered satisfactorily and the patient understood and agreed to the plan. Provided the patient with my contact information for any questions or concerns. Follow-up in 3 months for a refill or PRN. \n",
  },
  {
    Id: 235,
    TemplateTitle: "Approve - Synch - UpScriptCare Migraine",
    TemplateText:
      "S: Introduced myself and confirmed the patient's name and DOB. <<Age>> year old <<gender>> requests an Rx to treat migraines. Medical consult, patient’s current medications, and patient’s current allergies reviewed and all are noncontributory unless otherwise noted here. \nPatient does not have uncontrolled hypertension, heart disease or condition, history of stroke, peripheral vascular disease, or ischemic bowel disease.  Patient medical history does not indicate headaches due to medication overuse.\nPatient experiences __________ migraine days per month with an average pain rate of ________.\nTo prevent migraines, the patient has tried ___________  and failed due to ___________ \nFor the acute treatment of migraines, the patient has tried ___________  and failed due to ___________ \n\nO: Synchronous Visit.  Current BMI <<BMI>>, lucid and clear, speaking full sentences, respiratory unlabored. Normal blood pressure reported. \n\nA: Migraine Headaches. ICD-10 code <<ICD_CODES_AND_DESCRIPTIONS>>\n\nP: _____________ approved. Given the number of migraine days, severity of symptoms, and history of medications tried and failed, the patient will benefit from the use of medication for the acute treatment of migraines.  Review of the patient’s medical file, including current medications, demonstrates no apparent contraindications for use. All questions were answered satisfactorily and the patient understood and agreed to the plan. Provided the patient with my contact information for any questions or concerns. Follow-up in 3 months for a refill or PRN. \n",
  },
  {
    Id: 236,
    TemplateTitle: "Deny -  Synch - UpScriptCare Migraine",
    TemplateText:
      "S: Introduced myself and confirmed the patient's name and DOB. <<Age>> year old <<gender>> requests an Rx to treat migraines. Medical consult, patient’s current medications, and patient’s current allergies reviewed and all are noncontributory unless otherwise noted here. \nPatient does not have uncontrolled hypertension, heart disease or condition, history of stroke, peripheral vascular disease, or ischemic bowel disease.  Patient medical history does not indicate headaches due to medication overuse.\nPatient experiences __________ migraine days per month with an average pain rate of ________.\nTo prevent migraines, the patient has tried ___________  and failed due to ___________ \nFor the acute treatment of migraines, the patient has tried ___________  and failed due to ___________ \n\nO: Synchronous Visit.  Current BMI <<BMI>>, lucid and clear, speaking full sentences, respiratory unlabored. Normal blood pressure reported. \n\nA: Migraine Headaches. ICD-10 code <<ICD_DESCRIPTIONS_AND_CODES>>\n\nP: Migraine medication denied due to ______________. \nAll questions were answered satisfactorily and the patient understood and agreed to the plan. Provided the patient with my contact information for any questions or concerns. Follow-up with local provider.\n",
  },
];
